/** Evento global para mostrar toasts de sesión sin Context ni dependencias extra */
export const SESSION_TOAST_EVENT = 'aaz-session-toast';

export function showSessionToast(message) {
    if (typeof window === 'undefined' || !message) return;
    window.dispatchEvent(new CustomEvent(SESSION_TOAST_EVENT, { detail: { message } }));
}

function normalizeLang(lang) {
    if (!lang) return 'en';
    const l = String(lang).toLowerCase();
    if (l === 'de' || l === 'deutsch' || l === 'german') return 'de';
    return 'en';
}

export function signedInMessage(lang) {
    return normalizeLang(lang) === 'de'
        ? 'Sie sind erfolgreich angemeldet.'
        : 'You have successfully signed in.';
}

export function signedOutMessage(lang) {
    return normalizeLang(lang) === 'de'
        ? 'Sie wurden abgemeldet.'
        : 'You have been signed out.';
}

export function showSignedInToast(lang) {
    showSessionToast(signedInMessage(lang));
}

export function showSignedOutToast(lang) {
    showSessionToast(signedOutMessage(lang));
}
